/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import { Card, Icon, MenuItem, Switch } from "@mui/material";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import ExperienceData from "../../tables/data/experienceTableData";
import EducationsData from "../../tables/data/educationTableData";
import Tags from "../components/Tags";
import MDAvatar from "components/MDAvatar";
import team2 from "assets/images/team-2.jpg";
import { useLocation } from "react-router-dom";
import building from "assets/images/building.png";
import { useEffect, useState } from "react";
import { getProfile } from "api";
import moment from "moment";
import { Capitalize } from "utilities";
import { getSponsors } from "api";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import { updateCompanyProfile } from "api";

function CompanyDetail() {
  const navigate = useNavigate();

  const { sales, tasks } = reportsLineChartData;

  const location = useLocation();
  const { company } = location.state || {};
  const [profile, setProfile] = useState(company);
  const [selectedSponsor, setSelectedSponsor] = useState(company?.sponsors);
  const [arrData, setArrData] = useState([]);
  const [isEntrepreneur, setEntrepreneur] = useState(company?.isEntrepreneur || false);

  useEffect(() => {
    getSponsorsApi();
  }, []);

  const getSponsorsApi = () => {
    var params = {
      page: 1,
      limit: 1000,
    };

    getSponsors({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            setArrData([{ key: "none", name: "None" }, ...responseJson?.sponsors]);
          }
        }
      })
      .catch((e) => {});
  };

  const updateCompanyProfileApi = () => {
    var params = { sponsors: selectedSponsor?._id || null, isEntrepreneur: isEntrepreneur };

    updateCompanyProfile({
      params: params,
      id: profile?._id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            navigate(-1);
          }
        }
      })
      .catch((e) => {
        dispatch(spinnerAction.hideSpinner());
      });
  };

  const IndustryView = () => {
    const industries = Array.isArray(profile?.industry)
      ? profile?.industry.map((i) => i?.name)
      : profile?.industry;

    return (
      <MDBox pt={0}>
        <MDTypography variant="h6">Industry</MDTypography>

        <Tags
          tags={industries || []}
          // onRemove={(tag) => console.log("Remove:", tag)}
          isMyProfile={false}
        />
      </MDBox>
    );
  };

  const LocationView = () => {
    return (
      <MDBox pt={3}>
        <MDTypography variant="h6">Other Branch</MDTypography>

        <Tags
          tags={profile?.locations || []}
          // onRemove={(tag) => console.log("Remove:", tag)}
          isMyProfile={false}
        />
      </MDBox>
    );
  };

  const CompanyWebsiteView = () => {
    return (
      <MDBox pt={3}>
        <MDTypography variant="h6">Company Website URL</MDTypography>

        <MDTypography mb={0.25} display="block" variant="caption">
          {profile?.companyWebsiteURL}
        </MDTypography>
      </MDBox>
    );
  };
  const CompanyGSTN = () => {
    return (
      <MDBox pt={3}>
        <MDTypography variant="h6">GSTN</MDTypography>

        <MDTypography mb={0.25} display="block" variant="caption">
          {profile?.gstn}
        </MDTypography>
      </MDBox>
    );
  };

  const CompanyOverView = () => {
    return (
      <MDBox pt={3}>
        <MDTypography variant="h6">Company Overview</MDTypography>

        <MDTypography mb={0.25} display="block" variant="caption">
          {profile?.companyOverview}
        </MDTypography>
      </MDBox>
    );
  };

  const CompanyHeadquarterAddressView = () => {
    return (
      <MDBox pt={3}>
        <MDTypography variant="h6">Headquarter Address</MDTypography>

        <MDTypography mb={0.25} display="block" variant="caption">
          {`${profile?.area}, ${profile?.street},`}
        </MDTypography>
        <MDTypography mb={0.25} display="block" variant="caption">
          {`${profile?.city}, ${profile?.state}, ${profile?.country}`}
        </MDTypography>
      </MDBox>
    );
  };

  const SponsorsView = () => {
    return (
      <MDBox pt={3} display="flex" gap={2} alignItems="center" mb={2}>
        <MDTypography variant="h6">Sponsor</MDTypography>
        <MDInput
          select
          label="Sponsor"
          value={JSON.stringify(selectedSponsor)}
          onChange={(e) => setSelectedSponsor(JSON.parse(e.target.value))}
          sx={{ minWidth: 200 }}
          InputProps={{ sx: { height: "44px" } }}
        >
          {arrData.map((item) => (
            <MenuItem key={item?.key} value={JSON.stringify(item)}>
              {item?.name}
            </MenuItem>
          ))}
        </MDInput>
      </MDBox>
    );
  };

  const handleSetEntrepreneur = () => setEntrepreneur(!isEntrepreneur);

  const EntrepreneurView = () => {
    return (
      <MDBox display="flex" alignItems="center">
        <MDTypography
          variant="h6"
          onClick={handleSetEntrepreneur}
          sx={{ cursor: "pointer", userSelect: "none" }}
        >
          Women Entrepreneur &nbsp;&nbsp;
        </MDTypography>
        <Switch checked={isEntrepreneur} onChange={handleSetEntrepreneur} />
      </MDBox>
    );
  };

  const ProfileDetailData = () => {
    const imgWidth = profile?.businessImageURL ? "100%" : "50%";
    const imgHeight = profile?.businessImageURL ? "100%" : "50%";
    const imgResize = profile?.businessImageURL ? "cover" : "contain";

    return (
      <MDBox p={3} display="flex" gap={2}>
        <MDAvatar
          src={profile?.businessImageURL || building}
          size="sm"
          sx={{
            width: "70px", // optional: control size
            height: "70px", // optional: control size
            border: "2px solid",
            borderColor: "success.main",
            "& img": {
              width: imgWidth,
              height: imgHeight,
              objectFit: imgResize,
              objectPosition: "center",
            },
          }}
        />
        <MDBox>
          <MDTypography display="block" variant="h5" fontWeight="medium" mb={0.5}>
            {profile?.businessName}
          </MDTypography>

          <MDTypography mb={0.25} display="block" variant="caption">
            {`${profile?.code} ${profile?.phone}`}
          </MDTypography>
          <MDTypography mb={0.25} display="block" variant="caption">
            {`${profile?.email}`}
          </MDTypography>
        </MDBox>
      </MDBox>
    );
  };

  const CompanyInfo = () => {
    return (
      <MDBox p={3}>
        <IndustryView />
        <CompanyWebsiteView />
        <CompanyOverView />
        <CompanyHeadquarterAddressView />
        {/* <LocationView /> */}
        <CompanyGSTN />
        <SponsorsView />
        <EntrepreneurView />
      </MDBox>
    );
  };

  const handleContinue = () => {
    updateCompanyProfileApi();
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar title={"Company"} />
      <MDBox py={3}>
        <Card>
          <ProfileDetailData />
          <CompanyInfo />
          <MDBox display="flex" gap={2} p={3}>
            <MDButton color="secondary" fullWidth onClick={handleCancel}>
              Cancel
            </MDButton>
            <MDButton color="success" fullWidth onClick={handleContinue}>
              Save
            </MDButton>
          </MDBox>
        </Card>
      </MDBox>
      <MDBox mb={2} />
      <Footer />
    </DashboardLayout>
  );
}

export default CompanyDetail;
